'use client';

import React from 'react';
import { LocalizedLink } from '@/components/LocalizedLink';
import { useTranslations } from '@/hooks/useTranslations';
import { ErrorPageShell } from '@/components/ErrorPageShell';
import { ErrorIllustration } from '@/components/ErrorPageIllustration';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t } = useTranslations();
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(error);
  }, [error]);

  return (
    <ErrorPageShell>
    <div className="px-6 py-16">
      <div className="mx-auto w-full max-w-5xl">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-8">
          <div className="mb-4 flex justify-center">
            <ErrorIllustration />
          </div>
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-[#15192b] px-3 py-1 text-xs text-slate-300">
            Error
            {error?.digest ? (
              <span className="text-slate-500">• Digest: {error.digest}</span>
            ) : null}
          </div>
          <h1 className="mt-4 text-3xl font-semibold text-white">{t('error.title')}</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-400">
            {t('error.description')}
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={reset}
              className="rounded-full bg-[#ffb74d] px-4 py-2 text-xs font-semibold text-[#4a2800]"
            >
              {t('error.tryAgain')}
            </button>
            <LocalizedLink
              href="/"
              className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold text-slate-200 hover:bg-white/10"
            >
              {t('error.goHome')}
            </LocalizedLink>
            <LocalizedLink
              href="/contact"
              className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold text-slate-200 hover:bg-white/10"
            >
              {t('notFound.contactUs')}
            </LocalizedLink>
          </div>
        </div>
      </div>
    </div>
    </ErrorPageShell>
  );
}

